import type { AgentWithPresence } from './AgentPresenceTypes.ts';

const AGENT_PRESENCE_INACTIVE_THRESHOLD_MS = 5 * 60 * 1000;

export const isAgentPresenceInactive = (agent: AgentWithPresence): boolean =>
	agent.lastActive !== undefined &&
	Date.now() - agent.lastActive >= AGENT_PRESENCE_INACTIVE_THRESHOLD_MS;
